import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetItmBrand/Main";
import Form from "./TbSetItmBrand/Form";

// Utils
import { getDataWithComp, getAlert } from "../../../utils/SamuiUtils";
import { InitialDataTbSetItem } from "../../../model/InitialData/InitialDataTbSetItem";
import Navbar from "../../components/Modal/Navbar";

const TbSetItmBrand = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataTbSetItem());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "Tb_Set_ItmBrand",
        "Order By Brand_Id"
      );
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      comp_id: item.Comp_Id,
      Brand_Id: item.Brand_Id,
      Brand_Code: item.Brand_Code,
      Brand_Name: item.Brand_Name,
      Brand_Status: item.Brand_Status,
    });
    setSelectedData(item);
  };

  return (
    <div className="Creditor">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลแบรนด์สินค้า"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลแบรนด์สินค้า"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetItmBrand;
